import { useTranslation } from "react-i18next";
import type { SampleOrderDetailDto } from "@hisense/shared";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { buildSampleOrderHtml, printSampleOrder } from "@/lib/printSampleOrder";
import { SaveAsPdfHint } from "@/components/domain/SaveAsPdfHint";
export function SamplePrintPreview({order,onClose}:{order:SampleOrderDetailDto;onClose:()=>void}) {
  const {t}=useTranslation();
  return <Modal title={`${t("sampleWorkspace.printPreview")} · ${order.sampleOrderNumber}`} closeLabel={t("common.close")} onClose={onClose}>
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line p-3"><SaveAsPdfHint /><Button onClick={()=>printSampleOrder(order)}>{t("common.print")}</Button></div>
    <iframe title={t("sampleWorkspace.printPreview")} sandbox="allow-same-origin" srcDoc={buildSampleOrderHtml(order)} className="min-h-[65dvh] w-full flex-1 bg-surface"/>
  </Modal>;
}
